var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatboxOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 2.25H3.65625C3.13456 2.25148 2.63466 2.45938 2.26577 2.82827C1.89688 3.19716 1.68898 3.69706 1.6875 4.21875V10.9688C1.68898 11.4904 1.89688 11.9903 2.26577 12.3592C2.63466 12.7281 3.13456 12.936 3.65625 12.9375H5.0625V15.75L8.35734 13.0029C8.40794 12.9606 8.47177 12.9375 8.5377 12.9375H14.3438C14.8654 12.936 15.3653 12.7281 15.7342 12.3592C16.1031 11.9903 16.311 11.4904 16.3125 10.9688V4.21875C16.311 3.69706 16.1031 3.19716 15.7342 2.82827C15.3653 2.45938 14.8654 2.25148 14.3438 2.25Z",
    stroke: "#909090",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatboxOutline);
export default __webpack_public_path__ + "static/media/chatbox-outline.35295f59b4fa9dce1104e0dde107b9f7.svg";
export { ForwardRef as ReactComponent };